var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AuthManager_instances, _AuthManager_authentication, _AuthManager_requestPromises, _AuthManager_seenTokens, _AuthManager_tokens, _AuthManager_expiryTimes, _AuthManager_init, _AuthManager_getCachedToken, _AuthManager_getAuthRequest, _AuthManager_passWhitelist;
import { ERROR_EXPIRED_TOKEN } from "./constants/errors";
import { TOKEN } from "./constants/token";
import { ECode } from "./enums/ECode";
export class AuthManager {
    constructor(options) {
        _AuthManager_instances.add(this);
        _AuthManager_authentication.set(this, void 0);
        _AuthManager_requestPromises.set(this, new Map());
        _AuthManager_seenTokens.set(this, new Set());
        _AuthManager_tokens.set(this, []);
        _AuthManager_expiryTimes.set(this, []);
        __classPrivateFieldSet(this, _AuthManager_authentication, __classPrivateFieldGet(this, _AuthManager_instances, "m", _AuthManager_init).call(this, options), "f");
    }
    setApiKey(options) {
        __classPrivateFieldSet(this, _AuthManager_authentication, __classPrivateFieldGet(this, _AuthManager_instances, "m", _AuthManager_init).call(this, options), "f");
    }
    reset() {
        __classPrivateFieldSet(this, _AuthManager_tokens, [], "f");
        __classPrivateFieldSet(this, _AuthManager_expiryTimes, [], "f");
        __classPrivateFieldSet(this, _AuthManager_seenTokens, new Set(), "f");
        __classPrivateFieldSet(this, _AuthManager_requestPromises, new Map(), "f");
    }
    getOrigin() {
        return __classPrivateFieldGet(this, _AuthManager_authentication, "f").url;
    }
    async getAuthValue() {
        const cachedToken = __classPrivateFieldGet(this, _AuthManager_instances, "m", _AuthManager_getCachedToken).call(this);
        if (cachedToken != undefined) {
            return {
                type: "secret",
                token: cachedToken,
            };
        }
        if (__classPrivateFieldGet(this, _AuthManager_seenTokens, "f").size > 0) {
            return {
                type: "expired_token",
                token: null,
            };
        }
        const MEMBERSHIP_KEY = "membership-user-token";
        let currentPromise = __classPrivateFieldGet(this, _AuthManager_requestPromises, "f").get(MEMBERSHIP_KEY);
        if (__classPrivateFieldGet(this, _AuthManager_authentication, "f").type === "public") {
            return {
                type: "no_token",
                token: null,
            };
        }
        if (currentPromise == null) {
            currentPromise = __classPrivateFieldGet(this, _AuthManager_instances, "m", _AuthManager_getAuthRequest).call(this, {
                apiKey: __classPrivateFieldGet(this, _AuthManager_authentication, "f").apiKey,
            });
            __classPrivateFieldGet(this, _AuthManager_requestPromises, "f").set(MEMBERSHIP_KEY, currentPromise);
        }
        try {
            const token = await currentPromise;
            const expiresAt = Math.floor(Date.now() / 1000) +
                (token.parsed.exp - token.parsed.iat) -
                Math.floor(TOKEN.BUFFER / 1000);
            __classPrivateFieldGet(this, _AuthManager_seenTokens, "f").add(token.raw);
            __classPrivateFieldGet(this, _AuthManager_tokens, "f").push(token);
            __classPrivateFieldGet(this, _AuthManager_expiryTimes, "f").push(expiresAt);
            return {
                type: "secret",
                token,
            };
        }
        catch (error) {
            if (error instanceof Error &&
                error.message.startsWith(ERROR_EXPIRED_TOKEN)) {
                return {
                    type: "expired_token",
                    token: null,
                };
            }
            return {
                type: "error",
                reason: String(error),
            };
        }
        finally {
            __classPrivateFieldGet(this, _AuthManager_requestPromises, "f").delete(MEMBERSHIP_KEY);
        }
    }
}
_AuthManager_authentication = new WeakMap(), _AuthManager_requestPromises = new WeakMap(), _AuthManager_seenTokens = new WeakMap(), _AuthManager_tokens = new WeakMap(), _AuthManager_expiryTimes = new WeakMap(), _AuthManager_instances = new WeakSet(), _AuthManager_init = function _AuthManager_init(options) {
    const { apiKey, origin } = options;
    const ORIGIN = "https://memb.dev.ciety.dev";
    if (typeof apiKey === "string") {
        return {
            type: "private",
            apiKey,
            url: origin !== null && origin !== void 0 ? origin : ORIGIN,
        };
    }
    return {
        type: "public",
        apiKey: null,
        url: origin !== null && origin !== void 0 ? origin : ORIGIN,
    };
}, _AuthManager_getCachedToken = function _AuthManager_getCachedToken() {
    const now = Math.ceil(Date.now() / 1000);
    const tokens = __classPrivateFieldGet(this, _AuthManager_tokens, "f").slice();
    const expiryTimes = __classPrivateFieldGet(this, _AuthManager_expiryTimes, "f").slice();
    for (let i = tokens.length - 1; i >= 0; i--) {
        const token = tokens[i];
        const expiresAt = expiryTimes[i];
        // 시간 만료
        if (expiresAt <= now) {
            tokens.splice(i, 1);
            expiryTimes.splice(i, 1);
            continue;
        }
        return token;
    }
    return null;
}, _AuthManager_getAuthRequest = async function _AuthManager_getAuthRequest(params) {
    if (__classPrivateFieldGet(this, _AuthManager_instances, "m", _AuthManager_passWhitelist).call(this)) {
        return parseAuthToken(params.apiKey);
    }
    const res = await fetch(`${__classPrivateFieldGet(this, _AuthManager_authentication, "f").url}/user`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "x-api-key": params.apiKey,
        },
    });
    if (!res.ok) {
        const reason = `${(await res.text()).trim() || "reason not provided in auth response"} (${res.status} returned by POST ${__classPrivateFieldGet(this, _AuthManager_authentication, "f").url})`;
        throw new Error(`Failed to authenticate: ${reason}`);
    }
    const { code } = await res.json();
    if (code === ECode.Success) {
        const parsed = parseAuthToken(params.apiKey);
        return parsed;
    }
    else if (code === ECode.ExpiredToken) {
        throw new Error(ERROR_EXPIRED_TOKEN);
    }
    else {
        throw new Error(`Unexpected code ${code}`);
    }
}, _AuthManager_passWhitelist = function _AuthManager_passWhitelist() {
    var _a;
    if (typeof window != "object") {
        return false;
    }
    const WHITE_LIST = ["marpple", "ciety"];
    const regex = /(.+)\.(.+)/;
    const matched = (_a = window.location.hostname.match(regex)) === null || _a === void 0 ? void 0 : _a[1];
    if (matched == null) {
        return false;
    }
    for (const hostname of WHITE_LIST) {
        if (matched.endsWith(hostname)) {
            return true;
        }
    }
    return false;
};
function parseAuthToken(rawTokenString) {
    const tokenParts = rawTokenString.split(".");
    if (tokenParts.length !== 3) {
        throw new Error("Authentication error: invalid JWT token");
    }
    const payload = tryParseJson(b64decode(tokenParts[1]));
    return {
        raw: rawTokenString,
        parsed: payload,
    };
}
function tryParseJson(rawMessage) {
    try {
        return JSON.parse(rawMessage);
    }
    catch (_a) {
        return undefined;
    }
}
function b64decode(b64value) {
    try {
        const formattedValue = b64value.replace(/-/g, "+").replace(/_/g, "/");
        const decodedValue = decodeURIComponent(atob(formattedValue)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""));
        return decodedValue;
    }
    catch (_a) {
        return atob(b64value);
    }
}
//# sourceMappingURL=auth-manager.js.map